import React, { HTMLAttributes } from 'react';

interface Props {
  icon?: string
}

const Error: React.FC<Props & HTMLAttributes<HTMLDivElement>> = (props) => {

  return (
    <div className={'alert btn-danger'} style={{ padding: '6px 26px 15px', margin: '6px 0 23px' }}>
      <div className='alert-watermark' style={{ zIndex: 2, fontSize: '200%', textShadow: 'none' }}>
        <span
          className={'fas fa-' + (props.icon ?? 'exclamation-triangle')}
          style={{ fontSize: '600%', left: -20, opacity: .1, position: 'absolute', top: '5%' }}
        />
      </div>
      <div className='alert-offset' style={{ zIndex: 3, position: 'relative' }}>
        {props.children}
      </div>
    </div >
  );
}

export default Error;